import { Organisation } from '../models/organisation';

type JobOrganisation = {
  id: string;
  name: string;
  customerName?: string;
};

export function getDepartmentDisplayName(
  departmentName: string,
  organisation: JobOrganisation | Organisation,
): string {
  return `${
    organisation.customerName ? organisation.customerName + ' - ' : ''
  }${organisation.name} - ${departmentName}`;
}
